/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/application_flow/application_flow';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SearchApplicationFlowsRequest": {
                "fields": {
                  "filter": {
                    "type": ".squareup.corporate_card.service.SearchApplicationFlowsRequest.Filter",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Filter": {
                    "fields": {
                      "merchantIds": {
                        "type": "string",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "SearchApplicationFlowsResponse": {
                "fields": {
                  "applicationFlows": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchApplicationFlowsRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchApplicationFlowsRequest?.nested?.Filter && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SearchApplicationFlowsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchApplicationFlowsRequest @ squareup/corporate_card/service/search_application_flows.proto at 9:1
 */
export const SearchApplicationFlowsRequest = $root.lookupType('squareup.corporate_card.service.SearchApplicationFlowsRequest');
fixType(SearchApplicationFlowsRequest);
Builder.createAndAttachToType(SearchApplicationFlowsRequest);
/**
 * SOURCE Filter @ squareup/corporate_card/service/search_application_flows.proto at 10:3
 */
SearchApplicationFlowsRequest.Filter = $root.lookupType('squareup.corporate_card.service.SearchApplicationFlowsRequest.Filter');
fixType(SearchApplicationFlowsRequest.Filter);
Builder.createAndAttachToType(SearchApplicationFlowsRequest.Filter);
/**
 * SOURCE SearchApplicationFlowsResponse @ squareup/corporate_card/service/search_application_flows.proto at 18:1
 */
export const SearchApplicationFlowsResponse = $root.lookupType('squareup.corporate_card.service.SearchApplicationFlowsResponse');
fixType(SearchApplicationFlowsResponse);
Builder.createAndAttachToType(SearchApplicationFlowsResponse);